import React, { useEffect, useState } from 'react'
import { TextField, Typography, LinearProgress, makeStyles, Theme, createStyles, Paper, MenuItem, Checkbox, useMediaQuery, useTheme } from '@material-ui/core'
import { Switch } from 'formik-material-ui';
import Constants, { OptionType, breakpoint } from '../../types/constants';
import { IGlobalState, InEditingMode } from '../../states/GlobalState';
import { Formik, FormikProps, Form, Field, FastField } from 'formik'
import { useGlobal, useDispatch } from 'reactn'
import { useHistory } from 'react-router-dom'
import { Principal } from '../../models/principal';
import LockIcon from '@material-ui/icons/Lock';
import { UamSelectField, UamSwitchField, UamTextField } from '../../formik/UamTextField';
import { PrincipalServiceValidation } from '../../core/principal/principalFunctions';
import Auth, {getLevels} from '../../types/auth';
import { updatePrincipal, createPrincipal, usernameExists } from '../../services/principalService';
import { useLogger } from '../../logger';
import ErrorSummary from '../../formik/ErrorSummary';
import { Company } from '../../models/company';
import { Roles } from '../../models';
import { KeyboardDatePicker } from '@material-ui/pickers';

const contentMaxWidth = Constants.PageEditPrincipalContentMaxWidth;

const useStyles = makeStyles((theme: Theme) => createStyles({
    root: {
        overflow: 'auto',
        marginTop: theme.spacing(2),
    },
    error: {
        color: theme.palette.secondary.main,
    },
    fieldContainer: {
        // width: 'auto',
        padding: 10,
        marginBottom: 20,
    },
    passwContainer: {
        padding: 10,
        marginBottom: 0,
        marginTop: 10,
    },
    disflex: {
        display: 'flex',
    },
    id: {

    },
    disflexdistr: {
        display: 'flex',
        alignContent: 'space-between',
    },
}))

const formTextFieldMargin = 'dense'
export type SaveDataType = {
    values: any[]
}
type PrincipalFieldsPropsType = {
    onLockedChange?: (isLocked: boolean) => void,
    onModifiedChange?: (isModified: boolean) => void,
    setSubmitCallback?: (callback: () => Promise<any>) => void,
    setRefreshCallback?: (callback: () => void) => void,
    onSubmit?: () => void,
}

export default function PrincipalFields(props: PrincipalFieldsPropsType) {
    const theme = useTheme();
    const [currentEditPrincipalStatus,] = useGlobal<IGlobalState, 'currentEditPrincipalStatus'>('currentEditPrincipalStatus');
    const [currentEditPrincipal, ] = useGlobal<IGlobalState, 'currentEditPrincipal'>('currentEditPrincipal');
    const [auth] = useGlobal<IGlobalState, 'auth'>('auth');
    const [ip] = useGlobal<IGlobalState, 'ip'>('ip');
    const [identity,] = useGlobal<IGlobalState, 'identity'>('identity');
    const [licenseNumber,] = useGlobal<IGlobalState, 'licenseNumber'>('licenseNumber');
    const [globalWait, setGlobalWait] = useGlobal<IGlobalState, 'globalWait'>('globalWait');
    const classes = useStyles();
    const [companies] = useGlobal<IGlobalState, 'companies'>('companies');
    const mobile = useMediaQuery(theme.breakpoints.down(breakpoint));
    
    const adLevels = getLevels(auth.authData);
    const [principalService] = useState(() => new PrincipalServiceValidation(adLevels))
    // const closeDialog = () => setPromptDialogProps({ open: false })
    const dispatch = useDispatch();
    const history = useHistory();
    const logger = useLogger({key: 'principalFields'});
    const principalFormSchema = principalService.principalFormSchemaBase();
    const [roleList, setRoleList]= useState<OptionType[]>([]);
    const [companyList, setCompanyList]= useState<OptionType[]>([]);
    let width = mobile ? 'auto' : contentMaxWidth;

    const loadCompaniesForPrincipal = async () => {
        // getCompanies(ip, auth.authData!, auth.user!, new CompanySearchModel()).then(res => {
        let myRoles: OptionType[]=[];
        if (currentEditPrincipal?.mode === InEditingMode.Edit) {
            myRoles.push({label: Roles.SUPERADMIN, value: Roles.SUPERADMIN});
            myRoles.push({label: Roles.ADMIN, value: Roles.ADMIN});
            // myRoles.push({label: Roles.MANAGER, value: Roles.MANAGER});
            myRoles.push({label: Roles.DEMO, value: Roles.DEMO});
        }
        if (currentEditPrincipal?.mode === InEditingMode.New && identity?.Role === Roles.SUPERADMIN) {
            myRoles.push({label: Roles.SUPERADMIN, value: Roles.SUPERADMIN});
            myRoles.push({label: Roles.ADMIN, value: Roles.ADMIN});
            myRoles.push({label: Roles.DEMO, value: Roles.DEMO});
        }
        if (currentEditPrincipal?.mode === InEditingMode.New && identity?.Role === Roles.ADMIN) {
            myRoles.push({label: Roles.DEMO, value: Roles.DEMO});
        }
        myRoles.push({label: Roles.MANAGER, value: Roles.MANAGER});
        myRoles.push({label: Roles.OPERATOR, value: Roles.OPERATOR});
        setRoleList(myRoles);
        //Company
        let myCompanies: OptionType[]=[];
        companies.forEach((comp: Company) => {
            // console.log('Ciclo le my companies ora sono: ' + myCompanies.length);    
            let item: OptionType = {label: comp.BusinessName, value: comp.Id};
            myCompanies.push(item);
        });
        setCompanyList(myCompanies);
    }

    const getNomeMenuForfetari = (): string => {
        let nome = 'Forfetari';
        if (identity?.Company?.ForfetariMenuName) {
          nome = identity?.Company?.ForfetariMenuName;
        }
        return nome;
    }

    const getNomeMenuBudget = (): string => {
        let nome = 'Budget4u';
        if (identity?.Company?.BudgetMenuName) {
            nome = identity?.Company?.BudgetMenuName;
        }
        return nome;
    }
    
    const getNomeEasystart = (): string => {
        let nome = 'Easy start';
        if (identity?.Company?.EasystartName) {
            nome = identity?.Company?.EasystartName;
        }
        return nome;
    }
  
    console.log('has easy start company: ' + identity?.Company?.HasEasyStart);
    useEffect(() => {
        console.log('sono in use effect')
        loadCompaniesForPrincipal();
        if (currentEditPrincipal?.mode === InEditingMode.New) {
            console.log('Imposto la company: ' + currentEditPrincipal.principal.CompanyId);
            // currentEditPrincipal.principal.CompanyId = identity?.CompanyId;
        }
    }, [companies, currentEditPrincipal]);
        
    return (
        <div className={classes.root}>
            <Formik
                initialValues={{...currentEditPrincipal!.principal as Principal }}
                validationSchema={principalFormSchema}
                // validateOnMount={true}
                validateOnChange={true}
                onSubmit={(values, { setSubmitting }) => {
                    // console.log(`*** +++ Formik.onSubmit ${currentEditPrincipalStatus}`);
                    const updPrincipal = principalFormSchema.cast(values);
                    // A questo punto scegliamo se fare un'update o un add in base al valore di oid
                    if (updPrincipal!.Id > 0) {
                        updatePrincipal(ip, auth.authData!, auth.user!, updPrincipal).then(updatedPrincipal => {
                            // e qui dobbiamo sostituire l'utente in editing con quello modificato
                            if (updatedPrincipal) {
                                dispatch.principalSaved(updatedPrincipal);
                                logger.info(`Utente ${updatedPrincipal.Name} ${updatedPrincipal.Surname} salvato!`);
                            } else {
                                logger.error('Problemi nel salvataggio della principal');
                            }
                        }).catch(error => {
                            console.error('Error in saving Principal');
                            logger.error(error, 'error');
                        }).finally(() => {
                            setSubmitting(false);
                            props.onSubmit && props.onSubmit();
                        })
                    } else {
                        // TODO, check auth of identity
                        // if (!identity?.PrincipalAuth || identity?.PrincipalAuth.length === 0) {
                        //     logger.error('Creazione utente non possibile. Nessuno studio assegnato per l\'utente che esegue l\'operazione', 'CREAZIONE UTENTI');
                        //     setSubmitting(false);
                        //     props.onSubmit && props.onSubmit();
                        //     return;
                        // }
                        let agencyId: number | null = null; 
                        if (identity?.PrincipalAuth && identity?.PrincipalAuth.length > 0) {
                            agencyId = identity?.PrincipalAuth[0].AgencyId;
                        }
                        console.log('Agency dell\'identity che sta inserendo l\'utente: ' + agencyId);
                        updPrincipal.Id = 0;
                        // getActiveUsers(ip, auth.authData!, auth.user!, agencyId!).then((users: Principal[]) => {
                        //     console.log('I principals active for the agency are: ' + users.length);
                        //     if (users && users.length >= licenseNumber && agencyId !== null) {
                        //         logger.error('Non ci sono licenze disponibili per lo studio per attivare un utente');
                        //         setSubmitting(false);
                        //         props.onSubmit && props.onSubmit();
                        //         // return;
                        //     } else {
                        usernameExists(ip, auth.authData!, auth.user!, updPrincipal.Username).then(exists => {
                            if (exists) {
                                setSubmitting(false);
                                props.onSubmit && props.onSubmit();
                                logger.error('Nome utente già presente');
                                // return false;
                            } else {
                                setGlobalWait(true);
                                createPrincipal(ip, auth.authData!, auth.user!, updPrincipal, agencyId).then(response => {
                                    console.log('Principal add', response)
                                    if (response) {
                                        if (response.Id > 0) {
                                            // e qui dobbiamo sostituire l'utente in editing con quello modificato
                                            //aggiornare lo stato 
                                            dispatch.newPrincipalSaved(response.Id, response);
                                            values.Id = response.Id;
                                            values.InsertDate = response.InsertDate;
                                            logger.info(`Utente ${response.Username} aggiunto correttamente`);
                                        } else {
                                            const message = `Errore nel salvataggio: `;
                                            logger.error(message, 'error');
                                        }
                                    }
                                }).finally(() => {
                                    setSubmitting(false);
                                    props.onSubmit && props.onSubmit();
                                    setGlobalWait(false);
                                });
                        
                            }
                        });
                    }
                }}
            >
                {(formprops: FormikProps<Principal>) => {
                    const { isSubmitting, handleSubmit, values, dirty, submitForm, resetForm, isValid, errors, setFieldValue } = formprops;
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    // useEffect(() => {
                    //     //TODO
                    //     if (dirty) {
                    //         if (currentEditPrincipalStatus === 'Pristine') { setCurrentEditPrincipalStatus('Modified') }
                    //     } else {
                    //         if (currentEditPrincipalStatus === 'Modified') { setCurrentEditPrincipalStatus('Pristine') }
                    //     }
                    // }, [dirty])
                    if (props.setSubmitCallback) {
                        props.setSubmitCallback(submitForm);
                    } 
                    if (props.setRefreshCallback) {
                        props.setRefreshCallback(resetForm);
                    } 
                                        
                    //TODO per bloccare la navigazione se ho sporcato la form, step successivo
                    // const handleNavigationAttempt = (navigation: any, location: any, action: string) => {
                    //     console.log('handleNavigationAttempt', navigation, location, action)
                    //     setPromptDialogProps({
                    //         open: true,
                    //         cancel: () => { closeDialog(); navigation.cancel(); },
                    //         resume: () => {
                    //             closeDialog();
                    //             resetForm();
                    //             //TODO
                    //             setCurrentEditPrincipalStatus('Pristine');
                    //             navigation.resume();
                    //         },
                    //     })
                    //     return null;
                    // }

                    return (
                        <Form onSubmit={handleSubmit} translate>
                            {/* <ReactRouterPause handler={handleNavigationAttempt} when={dirty} /> */}
                            {/* <ConfirmNavigation {...promptDialogProps} /> */}
                            <Paper className={classes.fieldContainer} style={{width: width}}>
                                <div className={classes.disflex}>
                                    <TextField label='Id' margin={formTextFieldMargin} value={values.Id} name='Id' fullWidth={true} inputProps={{readOnly: true}}/>
                                    {values.Id > 0 ?
                                    <>
                                        &nbsp;
                                        <UamTextField label='Username' name='Username' fullWidth margin={formTextFieldMargin}
                                            inputProps={{readOnly: true}}
                                        />
                                    </>
                                    :
                                    <>
                                        &nbsp;
                                        <UamTextField label='Username' name='Username' fullWidth margin={formTextFieldMargin}
                                        />
                                    </>
                                    }
                                </div>
                                <div className={classes.disflex}>
                                    <UamTextField label='Nome' name='Name' fullWidth margin={formTextFieldMargin} />
                                    &nbsp;
                                    <UamTextField label='Cognome' name='Surname' fullWidth margin={formTextFieldMargin} />
                                </div>
                                <div className={classes.disflex}>
                                    <UamTextField label='Mail' name='Mail' fullWidth margin={formTextFieldMargin} />
                                    &nbsp;
                                    <UamTextField label='Phone' name='Phone' fullWidth margin={formTextFieldMargin} />
                                </div>
                                <div className={classes.disflex}>
                                    <UamTextField label='Cod.Fiscale' name='Taxcode' fullWidth margin={formTextFieldMargin} />
                                    {values.Id > 0 ?
                                    <>
                                    &nbsp;
                                    <UamSelectField label='Ruolo' options={roleList} name='Role' fullWidth helperText='' margin={formTextFieldMargin} 
                                        inputProps={{readOnly: true}}
                                    />
                                    </>
                                    :
                                    <>
                                    &nbsp;
                                    <UamSelectField label='Ruolo' options={roleList} name='Role' fullWidth helperText='' margin={formTextFieldMargin}/>
                                    </>
                                    }
                                </div>
                                <div className={classes.disflex}>
                                    <UamSelectField label='Company' options={companyList} name='CompanyId' fullWidth margin={formTextFieldMargin} />
                                    &nbsp;
                                    <Field as={KeyboardDatePicker} label='Disabled' name='Disabled' 
                                        clearable={true} 
                                        autoOk 
                                        format='DD/MM/YYYY' 
                                        fullWidth margin='dense' 
                                        // value={values.Disabled} 
                                        onChange={value => setFieldValue("Disabled", value)}
                                    />
                                </div>
                                <div className={classes.disflexdistr}>
                                    <UamSwitchField label={getNomeMenuForfetari()} name='ApplicationForfetari' type="checkbox" fullWidth margin={formTextFieldMargin} />
                                    &nbsp;
                                    <UamSwitchField label='Convenienza' name='ApplicationConvenienza' type="checkbox" fullWidth margin={formTextFieldMargin} />
                                </div>
                                <div className={classes.disflexdistr}>
                                    <UamSwitchField label={getNomeMenuBudget()} name='ApplicationBudget' type="checkbox" fullWidth margin={formTextFieldMargin} />
                                    &nbsp;
                                    {values.Role === Roles.OPERATOR || values.Role === Roles.DEMO ?
                                    <>
                                    <UamSwitchField label='Creazione utenti' name='UserCreation' type="checkbox" fullWidth margin={formTextFieldMargin}
                                        style={{disabled: true}} value={false}/>
                                    </>
                                    :
                                    <>
                                    <UamSwitchField label='Creazione utenti' name='UserCreation' type="checkbox" fullWidth margin={formTextFieldMargin}/>
                                    </>
                                    }
                                </div>
                                {values.Company?.HasEasyStart === true ?
                                    <div className={classes.disflexdistr}>
                                        <UamSwitchField label={getNomeEasystart()} name='ApplicationEasyStart' type="checkbox" fullWidth margin={formTextFieldMargin} />
                                    </div>
                                : null}
                                {identity?.Role === Roles.SUPERADMIN ?
                                    <div className={classes.disflexdistr}>
                                        <UamSwitchField label='Report utilizzo' name='ReportEnabled' type="checkbox" fullWidth margin={formTextFieldMargin} />
                                    </div>
                                : null}
                                {values.Disabled ?
                                    <div className={classes.disflex}>
                                        <LockIcon titleAccess='Utente disabilitato' color="primary"/>
                                    </div> : null}
                                {isSubmitting && <LinearProgress color='primary' />}
                            </Paper>
                            {!isValid && <ErrorSummary title='Errori da correggere' errors={errors} schema={principalFormSchema} />}
                            {/* <FormikDebugDisplay<Principal> hide={false} {...formprops} /> */}
                        </Form>
                    )
                    }
                }
            </Formik>
        </div>
    )
}


